/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TagFieldRenderer_taggable = {
    readonly tags: ReadonlyArray<{
        readonly name: string;
    }>;
    readonly " $fragmentRefs": FragmentRefs<"TagField_taggable">;
    readonly " $refType": "TagFieldRenderer_taggable";
};
export type TagFieldRenderer_taggable$data = TagFieldRenderer_taggable;
export type TagFieldRenderer_taggable$key = {
    readonly " $data"?: TagFieldRenderer_taggable$data;
    readonly " $fragmentRefs": FragmentRefs<"TagFieldRenderer_taggable">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TagFieldRenderer_taggable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Tag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagField_taggable"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
(node as any).hash = 'b7b1bc7ea65ef3711fff17ffccca8e1d';
export default node;
